import { useState, useEffect, useRef } from "react";
import "./style.css";
import icon_vitax_name from "../../images/Vitax/icon_vitax_name.svg";
import icon_vitax from "../../images/Vitax/icon_vitax.svg";
import homem_banner from "../../images/Vitax/homem_banner.webp";
import homem_negocio from "../../images/Vitax/homem_negocio.webp";
import vitax_screen from "../../images/Vitax/vitax_screen.webp";
import icon_tributario from "../../images/Vitax/icon_tributario.svg";
import icon_card from "../../images/Vitax/icon_card.svg";
import icon_grafico from "../../images/Vitax/grafico.svg";
import icon_stonks from "../../images/Vitax/stonks.avif";
import icon_stop from "../../images/Vitax/stop.avif";
import icon_ap from "../../images/Vitax/icon_ap.svg";
import icon_coin from "../../images/Vitax/icon_coin.svg";
import icon_x from "../../images/Vitax/icon_x.svg";
import icon_green_check from "../../images/Vitax/icon_green_check.svg";
import icon_keychain from "../../images/Vitax/icon_keychain.svg";
import icon_baixa from "../../images/Vitax/icon_baixa.svg";
import icon_flymoney from "../../images/Vitax/icon_flymoney.svg";
import icon_musculo from "../../images/Vitax/icon_musculo.svg";
import icon_alta from "../../images/Vitax/icon_alta.svg";
import icon_muchmoney from "../../images/Vitax/icon_muchmoney.svg";
import icon_ia from "../../images/Vitax/icon_ia.svg";
import icon_nuvem from "../../images/Vitax/icon_nuvem.svg";
import icon_tablet from "../../images/Vitax/icon_tablet.svg";
import mulher_negocio from "../../images/Vitax/mulher_negocio.webp";
import faq_contadores from "../../images/Vitax/faq_contadores.svg";
import faq_empresas from "../../images/Vitax/faq_empresas.svg";
import banner_vitax_2 from "../../images/Vitax/banner_vitax_2.webp";
import icon_eBusca from "../../images/Vitax/eBusca.svg";
import icon_simplesNacional from "../../images/Vitax/simplesNacional.svg";
import logo_exactus_cinza from "../../images/Certificado/logo_exactus_cinza.svg";
import Footer from "../../components/Footer/Footer";
import { NavLink } from "react-router-dom";
function Vitax() {
  const [hoveredIndexPassoCompra, setHoveredIndexPassoCompra] = useState(null);
  const [activeIndexContadores, setActiveIndexContadores] = useState(null);
  const [activeIndexEmpresas, setActiveIndexEmpresas] = useState(null);

  const secondSectionRef = useRef(null);
  const secondCardsSliderRef = useRef(null);
  const [scrollXSecond, setScrollXSecond] = useState(0);

  const ninethSectionRef = useRef(null);
  const ninethCardsSliderRef = useRef(null);
  const [scrollXNineth, setScrollXNineth] = useState(0);

  const useHorizontalScrollEffect = (
    sectionRef,
    sliderRef,
    setScroll,
    scrollFactor = 0.8
  ) => {
    useEffect(() => {
      const handleScroll = () => {
        if (!sectionRef.current || !sliderRef.current) return;

        const section = sectionRef.current;
        const slider = sliderRef.current;
        const wrapper = slider.parentElement;
        const wrapperWidth = wrapper?.clientWidth || 0;

        const rect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (rect.top < windowHeight && rect.bottom > 0) {
          const progress = Math.min(
            Math.max(1 - (rect.top + 1000) / windowHeight, 0),
            2
          );
          const maxScroll = slider.scrollWidth - wrapperWidth;
          const offset = Math.min(
            progress * maxScroll * scrollFactor,
            maxScroll + 200
          );
          setScroll(offset);

          const cards = slider.querySelectorAll(".card");
          cards.forEach((card) => {
            const cardEl = card;
            const cardRect = cardEl.getBoundingClientRect();
            const wrapperRect = wrapper.getBoundingClientRect();

            const cardLeft = cardRect.left - wrapperRect.left;
            const cardRight = cardRect.right - wrapperRect.left;

            const fadeStartLeft = -100;
            const fadeEndLeft = 1;
            const fadeStartRight = wrapper.clientWidth - 50;
            const fadeEndRight = wrapper.clientWidth + 100;

            let opacity = 1;

            // Fade à esquerda
            if (cardLeft < fadeEndLeft) {
              opacity = Math.max(
                0,
                (cardLeft - fadeStartLeft) / (fadeEndLeft - fadeStartLeft)
              );
            }

            // Fade à direita
            if (cardRight > fadeStartRight) {
              opacity = Math.min(
                opacity,
                (fadeEndRight - cardRight) / (fadeEndRight - fadeStartRight)
              );
            }

            cardEl.style.opacity = opacity.toString();
          });
        }
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, [sectionRef, sliderRef, setScroll, scrollFactor]);
  };

  useHorizontalScrollEffect(
    secondSectionRef,
    secondCardsSliderRef,
    setScrollXSecond,
    0.8
  );
  useHorizontalScrollEffect(
    ninethSectionRef,
    ninethCardsSliderRef,
    setScrollXNineth,
    3.5
  );

  const toggleContadores = (index) => {
    setActiveIndexContadores(activeIndexContadores === index ? null : index);
  };
  const toggleEmpresas = (index) => {
    setActiveIndexEmpresas(activeIndexEmpresas === index ? null : index);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const comoVitaxFunciona = [
    {
      numero: "01",
      titulo: "Envie os...",
      texto: <b>os arquivos XML e PGDAS sem precisar tratar antes.</b>,
    },
    {
      numero: "02",
      titulo: "O sistema..",
      texto: <b>analisa e organiza automaticamente todos os dados.</b>,
    },
    {
      numero: "03",
      titulo: "Defina o...",
      texto: <b>período inicial e final para fazer o processamento.</b>,
    },
    {
      numero: "04",
      titulo: "A Vitax entrega...",
      texto: (
        <b>
          um raio-x fiscal da empresa e visão gerencial para uma melhor tomada de decisão.
        </b>
      ),
    },
  ];

  const faqsContadores = [
    {
      pergunta:
        "Como a Vitax pode ajudar meu escritório contábil a ganhar produtividade?",
      resposta:
        "A Vitax automatiza a análise de XMLs e PGDAS, reduzindo retrabalho com conferência de NCM e classificação fiscal.",
    },
    {
      pergunta: "Posso usar a Vitax em vários clientes ao mesmo tempo?",
      resposta:
        "Sim. A plataforma permite incluir dezenas de CNPJs com visualização em lote e filtros por período, setor e competência.",
    },
    {
      pergunta:
        "Como a Vitax ajuda a organizar a rotina do escritório contábil?",
      resposta:
        "O sistema reduz tarefas manuais e operacionais ao centralizar todas as análises fiscais em um só lugar, com filtros automáticos por empresa, período e competência. Isso libera a equipe para atuar com mais foco e precisão.",
    },
    {
      pergunta: "Consigo gerar relatórios para recuperação de tributos?",
      resposta:
        "Sim. O sistema apresenta valores pagos a maior com base técnica, prontos para compor pedidos de ressarcimento ou compensação.",
    },
    {
      pergunta: "Como a Vitax contribui para minha contabilidade consultiva?",
      resposta:
        "Ele transforma dados técnicos em informação estratégica, elevando sua entrega de valor ao cliente.",
    },
    {
      pergunta: "É possível treinar minha equipe para usar a Vitax?",
      resposta:
        "Sim. Oferecemos treinamento remoto e suporte completo para integrar a Vitax à rotina do seu escritório.",
    },
    {
      pergunta:
        "O uso da Vitax pode ser um diferencial competitivo para captar clientes?",
      resposta:
        "Sim. Ao oferecer diagnóstico tributário e segurança fiscal, você entrega resultado financeiro real para o cliente.",
    },
    {
      pergunta: "Existem ferramentas que possam ser integradas a Vitax?",
      resposta:
        "Sim. A plataforma pode ser integrada com o buscador automatizado por Inteligência Artificial o eBusca e também pode ser intrgrado com o Simples Nacional Fácil, nossa plataforma que automatiza o processamento do Simples Nacional.",
    },
  ];

  const faqsEmpresarios = [
    {
      pergunta: "O que é NCM e como ele impacta minha empresa?",
      resposta:
        "O NCM (Nomenclatura Comum do Mercosul) define a carga tributária dos seus produtos. Se estiver errado, você pode pagar imposto a mais ou ser multado.",
    },
    {
      pergunta: "Como saber se estou pagando tributos indevidamente?",
      resposta:
        "Se sua empresa vende produtos monofásicos (como bebidas, cosméticos ou medicamentos) e nunca revisou os NCMs, a chance de erro é alta.",
    },
    {
      pergunta: "A Vitax ajuda empresas do Simples Nacional?",
      resposta:
        "Sim. O foco principal da ferramenta é justamente evitar que empresas do Simples paguem tributos em duplicidade por erro de cadastro fiscal.",
    },
    {
      pergunta: "Quanto posso recuperar com a Vitax?",
      resposta:
        "O valor varia conforme os produtos e períodos analisados. Já tivemos casos com recuperação superior a R$ 100 mil em 60 meses.",
    },
    {
      pergunta: "É seguro enviar meus documentos fiscais para análise?",
      resposta:
        "Sim. Toda a análise é feita em ambiente seguro, com criptografia e rastreamento de dados. Nenhuma informação é compartilhada com terceiros.",
    },
    {
      pergunta: "Preciso saber mexer em sistema para usar a Vitax?",
      resposta:
        "Não. Basta enviar os arquivos XMLs e PGDAS. O sistema faz todo o cruzamento e entrega um painel com as informações organizadas.",
    },
    {
      pergunta: "Como funciona a recuperação de impostos pagos indevidamente?",
      resposta:
        "Após a análise, você pode entrar com pedido de ressarcimento ou compensação junto à Receita, com base nos relatórios da Vitax.",
    },
    {
      pergunta: "Posso testar a plataforma antes de contratar?",
      resposta:
        "Sim. O teste gratuito permite usar a Vitax com até duas empresas por 15 dias, sem compromisso ou cobrança.",
    },
  ];

  return (
    <>
      <div className="main-content">
        <section className="first-section">
          <div className="first-description">
            <img
              src={icon_vitax_name}
              alt="Icone Vitax"
              className="icon-vitax"
            />
            <h1 className="main-title">
              Inteligência Fiscal <span className="text-gold">Integrada</span>
            </h1>
            <p className="paragraph">
              Detecta inconsistências na classificação tributária e no cadastro de produtos com o apoio de inteligência artificial.
            </p>
            <button className="button-gold">Teste agora!</button>
          </div>
          <img className="img_banner" src={homem_banner} alt="Homem Banner" />
        </section>

        <section ref={secondSectionRef} className="second-section">
          <div className="second-description">
            <span className="secondary-title">
              Seu cadastro fiscal pode estar fazendo você{" "}
              <span className="text-gold">
                pagar mais impostos do que deveria.
              </span>
            </span>
          </div>
          <div className="second-card">
            <div
              className="cards-slider"
              ref={secondCardsSliderRef}
              style={{
                transform: `translateX(-${scrollXSecond}px)`,
                transition: "transform 0.1s ease-out",
                display: "flex",
                gap: "30px",
              }}
            >
              <div className="card">
                <figure>
                  <img
                    src={icon_grafico}
                    alt="Ícone gráfico pizza"
                    width={155}
                  />
                </figure>
                <div>
                  <h3>
                    85% das empresas do{" "}
                    <span className="text-gold">Simples erram o NCM</span>
                  </h3>
                  <p>
                    Com a Reforma Tributária em andamento, erros no cadastro de
                    produtos (NCMs) se tornaram um risco real para quem vende,
                    quem administra e quem contabiliza.
                  </p>
                </div>
              </div>
              <div className="card">
                <figure>
                  <img src={icon_stonks} alt="Ícone stonks" width={180} />
                </figure>
                <div>
                  <h3>
                    Inconsistência não é detalhe.{" "}
                    <span className="text-gold">É risco</span>
                  </h3>
                  <p>
                    Milhares de empresas enviam SPED com erros que poderiam ser
                    evitados. A Vitax identifica falhas técnicas e cruzamentos
                    incoerentes antes da Receita.
                  </p>
                </div>
              </div>
              <div className="card">
                <figure>
                  <img src={icon_stop} alt="Ícone stop" width={160} />
                </figure>
                <div>
                  <h3>
                    Chega de validar{" "}
                    <span className="text-gold">NCMs na mão.</span>
                  </h3>
                  <p>
                    A Vitax automatiza a verificação, aponta inconsistências e
                    sugere classificações corretas com base em critérios fiscais
                    atualizados.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="second-section-mobile">
          <span className="secondary-title mobile-title">
            Seu cadastro fiscal pode estar fazendo você{" "}
            <b className="text-gold">pagar mais impostos do que deveria.</b>
          </span>
          <div className="second-card-mobile">
            <img src={icon_grafico} alt="Icone grafico" width={120} />
            <div className="card-mobile-content">
              <span>
                85% das empresas do{" "}
                <b className="text-gold">Simples erram o NCM</b>
              </span>
              <p>
                Com a Reforma Tributária em andamento, erros no cadastro de
                produtos (NCMs) se tornaram um risco real para quem vende, quem
                administra e quem contabiliza.
              </p>
            </div>
          </div>
          <div className="second-card-mobile">
            <img src={icon_stonks} alt="Icone grafico" width={120} />
            <div className="card-mobile-content">
              <span>
                Inconsistência não é detalhe.{" "}
                <b className="text-gold">É risco.</b>
              </span>
              <p>
                Milhares de empresas enviam SPED com erros que poderiam ser
                evitados. A Vitax identifica falhas técnicas e cruzamentos
                incoerentes antes da Receita.
              </p>
            </div>
          </div>
          <div className="second-card-mobile">
            <img src={icon_stop} alt="Icone grafico" width={120} />
            <div className="card-mobile-content">
              <span>
                Chega de validar <b className="text-gold">NCMs na mão.</b>
              </span>
              <p>
                A Vitax automatiza a verificação, aponta inconsistências e
                sugere classificações corretas com base em critérios fiscais
                atualizados.
              </p>
            </div>
          </div>
        </section>

        <section className="third-section">
          <div className="third-description">
            <span className="secondary-title">
              Quem contratou <br />
              <span className="text-gold">a Vitax aprova a plataforma!</span>
            </span>
          </div>
          <div className="cards-third-section">
            <div className="card-third-section">
              <span className="card-third-title">
                AUTOPEÇAS <br />{" "}
                <span className="text-gold">mais controle</span>
              </span>
              <p className="card-third-paragraph">
                Achávamos que estava tudo certo, mas a Vitax mostrou que
                pagávamos além do necessário. Corrigimos, ganhamos controle e
                margem.
              </p>
              <p className="describ-card-third">
                ⭐⭐⭐⭐⭐ <br /> Daniel Rocha, Consultor Tributário Roda Forte
                Autopeças – PR
              </p>
            </div>
            <div className="card-third-section">
              <span className="card-third-title">
                Drogaria <br /> <span className="text-gold">ncm genérico</span>
              </span>
              <p className="card-third-paragraph">
                Vendíamos produtos com NCM genérico. A Vitax reorganizou nossa
                base, e hoje temos total clareza sobre a carga tributária da
                loja.
              </p>
              <p className="describ-card-third">
                ⭐⭐⭐⭐⭐ <br /> Juliana Prado, Contadora Especialista em
                Simples Nacional – MG
              </p>
            </div>
            <div className="card-third-section">
              <span className="card-third-title">
                MINI Mercado <br />{" "}
                <span className="text-gold">organização</span>
              </span>
              <p className="card-third-paragraph">
                Estávamos recolhendo tributos indevidos sobre bebidas. A Vitax
                organizou tudo e conseguimos ajustar a tributação de toda a
                loja.
              </p>
              <p className="describ-card-third">
                ⭐⭐⭐⭐⭐ <br /> Marcelo Ferreira, Contador Bela Vista – SP
              </p>
            </div>
          </div>
        </section>

        <section className="fourth-section">
          <div className="fourth-description">
            <span className="secondary-title">
              O que a VITAX <span className="text-gold"> faz ?</span>
            </span>
            <ul>
              <li>Identifica de forma inteligente inconsistências na classificação fiscal dos NCMs</li>
              <li>Identifica diferenças entre tributos pagos e os corretos.</li>
              <li>Organiza PGDAS e XMLs sem necessidade de filtro manual.</li>
              <li>Gera relatórios gerenciais por CNPJ, produto e faturamento.</li>
              <li>Visão clara para quem decide e para quem executa.</li>
            </ul>
          </div>
          <img src={vitax_screen} alt="Icone Vitax" width={650} />
        </section>

        <section className="fifth-section">
          <img
            className="fifth-banner"
            src={homem_negocio}
            alt="Homem Negócio"
            width={500}
          />
          <div className="fifth-description">
            <span className="secondary-title">
              Para quem a <span className="text-gold">Vitax foi feita?</span>
            </span>
            <div className="fifth-description-card">
              <img src={icon_card} alt="" />
              <div>
                <p>Contadores e empresas contábeis</p>
                <span>
                  Para ter maior produtividade e redução de retrabalho.
                </span>
              </div>
            </div>
            <div className="fifth-description-card">
              <img src={icon_ap} alt="" />
              <div>
                <p>Empresários e administradores</p>
                <span>
                  Para ter um controle real sobre o que estão pagando.
                </span>
              </div>
            </div>
            <div className="fifth-description-card">
              <img src={icon_coin} alt="" />
              <div>
                <p>Departamentos fiscais internos</p>
                <span>
                  A Vitax é a ferramenta ideal para validação e apuração.
                </span>
              </div>
            </div>
            <div className="fifth-description-card">
              <img src={icon_tributario} alt="" />
              <div>
                <p>Consultor Tributário</p>
                <span>A Vitax elimina análise manual e o retrabalho.</span>
              </div>
            </div>
          </div>
        </section>

        <section className="sixth-section">
          <span className="secondary-title">
            <span className="text-gold">Vitax</span> faz a diferença!
          </span>
          <p className="sixth-subtitle">
            Pequenos erros fiscais, grandes impactos financeiros.
          </p>
          <div className="sixth-card-container">
            <div className="sixth-card">
              <img src={icon_x} alt="Icone X" className="sixth-x-icon" />
              <span>Um NCM errado RESULTA: </span>
              <div className="sixth-card-list">
                <div className="sixth-card-title">
                  <img src={icon_keychain} alt="" width={25} />
                  <p className="sixth-title-list">Preços finais mais ALTOS</p>
                </div>
                <p className="sixth-card-descrip">
                  Com preços finais mais altos do que da sua concorrência
                  acabando com sua competitividade.
                </p>
              </div>
              <div className="sixth-card-list">
                <div className="sixth-card-title">
                  <img src={icon_baixa} alt="" width={25} />{" "}
                  <p className="sixth-title-list">Margens de lucro BAIXAS</p>
                </div>
                <p className="sixth-card-descrip">
                  Margens de lucro muito comprometidas afetando a saúde
                  financeira do seu negócio.
                </p>
              </div>
              <div className="sixth-card-list">
                <div className="sixth-card-title">
                  <img src={icon_flymoney} alt="" width={28} />{" "}
                  <p className="sixth-title-list">Mais IMPOSTOS para você</p>
                </div>
                <p className="sixth-card-descrip">
                  Pagamento de tributos a maior que poderiam ser evitados
                  estando em conformidade fiscal.
                </p>
              </div>
            </div>

            <div className="sixth-card">
              <img
                src={icon_green_check}
                alt="Icone X"
                className="sixth-x-icon"
              />
              <span>Um NCM certo GARANTE: </span>
              <div className="sixth-card-list">
                <div className="sixth-card-title">
                  <img src={icon_musculo} alt="" width={25} />{" "}
                  <p className="sixth-title-list">
                    <span className="text-gold">$AÚDE</span> da sua empresa
                  </p>
                </div>
                <p className="sixth-card-descrip">
                  Com a base fiscal estruturada, você toma decisões mais
                  rápidas, estratégicas e sustentáveis.
                </p>
              </div>
              <div className="sixth-card-list">
                <div className="sixth-card-title">
                  <img src={icon_alta} alt="" width={25} />{" "}
                  <p className="sixth-title-list">
                    Dados <span className="text-gold">CONFIÁVEI$</span>
                  </p>
                </div>
                <p className="sixth-card-descrip">
                  Diminuir impostos pagos à toa e recuperar as margens de lucro
                  para o seu negócio.
                </p>
              </div>
              <div className="sixth-card-list">
                <div className="sixth-card-title">
                  <img src={icon_muchmoney} alt="" width={28} />{" "}
                  <p className="sixth-title-list">
                    Margens de lucros <span className="text-gold">ALTA$</span>
                  </p>
                </div>
                <p className="sixth-card-descrip">
                  Com dados confiáveis, sua tomada de decisão se apoia em
                  números certos e projeções realistas.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="seventh-section">
          <div className="seventh-description">
            <span className="secondary-title">
              A realidade mudou.{" "}
              <span className="text-gold">
                A sua gestão fiscal também precisa mudar.
              </span>
            </span>
            <p className="paragraph">
              Se você vende produtos, o NCM é tão importante quanto o preço. E
              se você é contador ou tributarista, esse detalhe técnico define o
              futuro da empresa do seu cliente.
            </p>
            <button className="button-gold">Quero testar agora!</button>
            <button className="button-black">Fale com a gente!</button>
          </div>
          <img src={banner_vitax_2} alt="Banner Vitax" width={700} />
        </section>

        <section className="eighth-section">
          <article className="eighth-section-descricao">
            <h2 className="secondary-title">
              Como funciona <span className="text-gold">a Vitax?</span>
            </h2>
            <div className="eighth-lista">
              <img src={icon_ia} alt="Icone Ia" width={39} height={39} />
              <b>Inteligência Artificial integrada</b>
            </div>
            <div className="eighth-lista">
              <img src={icon_nuvem} alt="Icone Ia" width={39} height={39} />
              <b>100% SAAS disponível 24/7</b>
            </div>
            <div className="eighth-lista">
              <img src={icon_tablet} alt="Icone Ia" width={39} height={39} />
              <b>Plataforma White Label</b>
            </div>
          </article>
          <article className="eighth-section-passo-a-passo">
            {comoVitaxFunciona.map((passo, index) => (
              <div
                key={index}
                className={`eighth-section-passo-destaque ${
                  hoveredIndexPassoCompra === index ? "active" : ""
                }`}
                onMouseEnter={() => setHoveredIndexPassoCompra(index)}
                onMouseLeave={() => setHoveredIndexPassoCompra(null)}
              >
                <h3>{passo.numero}</h3>

                <article>
                  <div className="passo-header">
                    <h3>{passo.titulo}</h3>
                    <span
                      className={`arrow ${
                        hoveredIndexPassoCompra === index ? "rotate" : ""
                      }`}
                    >
                      ▾
                    </span>
                  </div>
                  <p
                    className={`passo-subtexto ${
                      hoveredIndexPassoCompra === index ? "active" : ""
                    }`}
                  >
                    {passo.texto}
                  </p>
                </article>
              </div>
            ))}
          </article>
        </section>

        <section ref={ninethSectionRef} className="nineth-section">
          <div className="nineth-description">
            <h2 className="secondary-title">
              Complete sua automação com as{" "}
              <span className="text-gold">soluções da Exactus</span>
            </h2>
            <p>
              Você já automatizou o diagnóstico com a Vitax. Que tal agora dar
              um passo a mais e integrar tudo em um fluxo realmente inteligente?
            </p>
          </div>
          <div className="nineth-cards">
            <div
              className="cards-slider"
              ref={ninethCardsSliderRef}
              style={{
                transform: `translateX(-${scrollXNineth}px)`,
                transition: "transform 0.1s ease-out",
                display: "flex",
                gap: "30px",
              }}
            >
              <div className="card card-nineth">
                <figure>
                  <img src={icon_eBusca} alt="Ícone eBusca" width={175} />
                </figure>
                <div>
                  <p>
                    O buscador de documentos fiscais digitais da Exactus. Ele
                    localiza e organiza XMLs diretamente da Sefaz, sem depender
                    do envio do cliente. Integrado a Vitax, ele potencializa a
                    eficiência da análise fiscal e reduz a margem de erro a
                    quase zero.
                  </p>
                </div>
                <NavLink to="/busca">
                  <button className="botao">Quero conhecer!</button>
                </NavLink>
              </div>
              <div className="card card-nineth">
                <figure>
                  <img
                    src={icon_simplesNacional}
                    alt="Ícone simplesNacional"
                    width={190}
                  />
                </figure>
                <div>
                  <p>
                    A plataforma automatizada com Inteligência Artificial para
                    apuração e entrega automática das obrigações do Simples
                    Nacional. Ele calcula, gera e envia os arquivos ao Fisco.
                    Com ele, você fecha o ciclo: da busca à entrega final.
                  </p>
                </div>
                <NavLink to="/simplesnacionalfacil">
                  <button className="botao">Quero conhecer!</button>
                </NavLink>
              </div>
            </div>
          </div>
        </section>
        <section
          className="second-section-mobile"
          style={{ backgroundColor: "white" }}
        >
          <span className="secondary-title mobile-title">
            Seu cadastro fiscal pode estar fazendo você{" "}
            <b className="text-gold">pagar mais impostos do que deveria.</b>
          </span>
          <div
            className="second-card-mobile"
            style={{ backgroundColor: "#F0F0F0" }}
          >
            <img src={icon_eBusca} alt="Icone grafico" width={120} />
            <div className="card-mobile-content">
              <p>
                O buscador de documentos fiscais digitais da Exactus. Ele
                localiza e organiza XMLs diretamente da Sefaz, sem depender do
                envio do cliente. Integrado a Vitax, ele potencializa a
                eficiência da análise fiscal e reduz a margem de erro a quase
                zero.
              </p>
              <NavLink to="/busca">
                <button className="button-black">Quero conhecer!</button>
              </NavLink>
            </div>
          </div>
          <div
            className="second-card-mobile"
            style={{ backgroundColor: "#F0F0F0" }}
          >
            <img src={icon_simplesNacional} alt="Icone grafico" width={120} />
            <div className="card-mobile-content">
              <p>
                A plataforma automatizada com Inteligência Artificial para
                apuração e entrega automática das obrigações do Simples
                Nacional. Ele calcula, gera e envia os arquivos ao Fisco. Com
                ele, você fecha o ciclo: da busca à entrega final.
              </p>
              <NavLink to="/simplesnacionalfacil">
                <button className="button-black">Quero conhecer!</button>
              </NavLink>
            </div>
          </div>
        </section>

        <section className="tenth-section">
          <img src={icon_vitax} alt="" />
          <span className="secondary-title" style={{ color: "#FFFFFFCC" }}>
            <b className="text-gold">Segurança</b> para quem administra <br />{" "}
            <b className="text-gold">Clareza</b> para quem executa <br />{" "}
            <b className="text-gold">Resultado</b> para quem decide
          </span>
        </section>

        <section className="eleventh-section">
          <div className="eleventh-description">
            <span className="secondary-title">
              Por que escolher <span className="text-gold"> a Vitax ?</span>
            </span>
            <ul>
              <li>Plataforma integrada de apuração.</li>
              <li>Análise e validação automática de arquivos digitais.</li>
              <li>Cruzamento inteligente de dados fiscais.</li>
              <li>Indicadores de risco e relatórios gerenciais.</li>
              <li>Atualizações automáticas de regras tributárias.</li>
              <li>Compatível com os principais ERPs do mercado.</li>
            </ul>
          </div>
          <img src={mulher_negocio} alt="" width={600} />
        </section>

        <section className="faq-section">
          <div className="faq-description">
            <span className="secondary-title">
              FAQ Dúvidas sobre <b className="text-gold">a Vitax!</b>
            </span>
            <p className="paragraph">
              Antes de contratar a Vitax, dê uma olhada nas perguntas que mais
              recebemos de quem está exatamente onde você está agora. Essas
              respostas rápidas podem esclarecer o que falta para você seguir
              com tranquilidade e segurança.
            </p>
          </div>
          <div className="faq-list">
            <div className="faq-column">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "60px",
                  marginBottom: "20px",
                }}
              >
                <img
                  src={faq_contadores}
                  alt="Icone Faq Contadores"
                  width={100}
                />{" "}
                <span style={{ fontSize: "25px", fontWeight: "700" }}>
                  Contadores
                </span>
              </div>
              <article className="certificado-duvidas-accordions">
                {faqsContadores.map((faq, index) => (
                  <div
                    className={`accordion-item ${
                      activeIndexContadores === index ? "active" : ""
                    }`}
                    key={index}
                  >
                    <div
                      className={`accordion-header ${
                        activeIndexContadores === index ? "active" : ""
                      }`}
                      onClick={() => toggleContadores(index)}
                    >
                      <h3>{faq.pergunta}</h3>
                      <button>
                        {activeIndexContadores === index ? "−" : "+"}
                      </button>
                    </div>
                    <div className="accordion-content">
                      <p>{faq.resposta}</p>
                    </div>
                  </div>
                ))}
              </article>
            </div>
            <div className="faq-column">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "60px",
                  marginBottom: "20px",
                }}
              >
                <img src={faq_empresas} alt="Icone Faq Empresas" width={85} />{" "}
                <span style={{ fontSize: "25px", fontWeight: "700" }}>
                  Empresas
                </span>
              </div>
              <article className="certificado-duvidas-accordions">
                {faqsEmpresarios.map((faq, index) => (
                  <div
                    className={`accordion-item ${
                      activeIndexEmpresas === index ? "active" : ""
                    }`}
                    key={index}
                  >
                    <div
                      className={`accordion-header ${
                        activeIndexEmpresas === index ? "active" : ""
                      }`}
                      onClick={() => toggleEmpresas(index)}
                    >
                      <h3>{faq.pergunta}</h3>
                      <button>
                        {activeIndexEmpresas === index ? "−" : "+"}
                      </button>
                    </div>
                    <div className="accordion-content">
                      <p>{faq.resposta}</p>
                    </div>
                  </div>
                ))}
              </article>
            </div>
          </div>
        </section>

        <section className="decisao-section">
          <div className="decisao-description">
            <span className="secondary-title">
              Se você chegou até aqui, <br />
              <span className="text-gold">sua decisão já começou.</span>
            </span>
            <p className="paragraph">
              A maioria dos contadores e empresários que chegaram a esse ponto
              da página já perceberam que há algo errado no jeito como estão
              lidando com o NCM.
            </p>
            <p className="paragraph">
              A diferença de quem fica parado de quem cresce é uma só: testar o
              Vitax agora.
            </p>
            <p className="paragraph">
              {" "}
              Você não precisa mudar tudo, só precisa ver com os próprios olhos
              o que está escondido nas entrelinhas dos seus tributos.
            </p>
            <button className="button-black">Teste grátis para 2 CNPJ</button>
          </div>
        </section>
      </div>
      <Footer footerWhik={true} />
    </>
  );
}

export default Vitax;
